import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, MapPin } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { useI18n } from "@/i18n";
import api from "@/api";
import { CraftsmanCard } from "@/components/CraftsmanCard";

export default function Craftsmen() {
  const { t, catName, cityName } = useI18n();
  const [params, setParams] = useSearchParams();
  const [cats, setCats] = useState([]);
  const [cities, setCities] = useState([]);
  const [list, setList] = useState([]);
  const [q, setQ] = useState(params.get("q") || "");
  const [city, setCity] = useState(params.get("city") || "");
  const [trade, setTrade] = useState(params.get("trade") || "all");

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data));
    api.get("/cities").then((r) => setCities(r.data));
  }, []);

  useEffect(() => {
    const p = {};
    if (q) p.q = q;
    if (city) p.city = city;
    if (trade && trade !== "all") p.trade = trade;
    api.get("/craftsmen", { params: p }).then((r) => setList(r.data));
    const sp = new URLSearchParams(p);
    setParams(sp, { replace: true });
    // eslint-disable-next-line
  }, [q, city, trade]);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-[#2D231F]">{t("craftsmen.title")}</h1>
      <p className="text-[#8C7A70] mt-2 mb-8">{t("craftsmen.subtitle")}</p>

      <div className="flex flex-col sm:flex-row gap-3 mb-10">
        <div className="flex-1 flex items-center gap-2 bg-white rounded-xl border border-[#EBDDD3] px-3">
          <Search className="w-4 h-4 text-[#A89A90]" />
          <Input data-testid="craftsmen-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("hero.searchPlaceholder")} className="border-0 shadow-none focus-visible:ring-0 px-0" />
        </div>
        <Select value={city || "all"} onValueChange={(v) => setCity(v === "all" ? "" : v)}>
          <SelectTrigger data-testid="craftsmen-city" className="sm:w-44 rounded-xl bg-white h-11"><SelectValue placeholder={t("hero.cityPlaceholder")} /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("hero.cityPlaceholder")}</SelectItem>
            {cities.map((c) => <SelectItem key={c} value={c}>{cityName(c)}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={trade} onValueChange={setTrade}>
          <SelectTrigger data-testid="craftsmen-trade" className="sm:w-52 rounded-xl bg-white h-11"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("craftsmen.allTrades")}</SelectItem>
            {cats.map((c) => <SelectItem key={c} value={c}>{catName(c)}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      {list.length === 0 ? (
        <p className="text-[#A89A90] py-20 text-center">{t("craftsmen.empty")}</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {list.map((c, i) => <CraftsmanCard key={c._id} c={c} index={i} />)}
        </div>
      )}
    </div>
  );
}